'use strict';

function EducationDetails() {

    var _this = this;
    var max_scl = 3;
    var max_qual_per_scl = $('#max_qual_per_scl').val();

    this.initEducationDetails = function () {

        $('select[data-qual-type]').on('change', function () {
            var scl = $(this).attr('data-scl');
            var qual = $(this).attr('data-qual');
            var val = $(this).val();
            _this.show_oth(scl, qual, val);

        });

        // attach an onclick event to the add school button
        // when clicked it calls the show_next_scl function
        $('input[id="add_scl"]').on('click', function () {
            _this.show_next_scl();
        });

        // attach an onclick event to the delete school buttons
        // when clicked they call the remove_qual function (passing in the school instance and the qualification instance)
        $('button[id="scl_delete"]').on('click', function () {
            var scl = $(this).attr('data-scl');
            if (window.confirm('Are you sure you want to remove this record? All information in this record will be removed.')) {
                _this.remove_scl(scl);
            }
        });

        // attach an onclick event to all of the add qualification buttons
        // when clicked they call the show_next_qual function (passing in the school instance)
        $('input[id="add_qual"]').on('click', function () {
            var scl = $(this).attr('data-scl');
            _this.show_next_qual(scl);
        });

        // attach an onclick event to all of the delete qualification buttons
        // when clicked they call the remove_qual function (passing in the school instance and the qualification instance)
        $('button[id="qual_delete"]').on('click', function () {
            var scl = $(this).attr('data-scl');
            var qual = $(this).attr('data-qual');
            _this.remove_qual(scl, qual);
        });


        // initiate tablesaw mode for table
        sits_tablesaw_widget('table[data-tablesaw-mode]', 'stack', true);

        _this.init_scl();
    };

    this.init_scl = function () {

        for (var scl = 1; scl <= max_scl; scl++) {

            var value = '';

            if ($('#IPQ_ASY_EDU' + scl).length) {
                value = $('#IPQ_ASY_EDU' + scl).val();
                if (value !== '') {
                    $('div[id="scl' + scl + '"]').removeClass('sv-hidden');
                }
            }

            if ($('#IPQ_ASY_EDINS' + scl).length) {
                value = $('#IPQ_ASY_EDINS' + scl).val();
                if (value !== '') {
                    $('div[id="scl' + scl + '"]').removeClass('sv-hidden');
                }
            }

            // initiate the quals for each school that has been entered
            _this.init_qual(scl);
        }

        _this.toggleAddSchoolButton();

        $('input[id="school_lookup"]').blur();
    };

    this.init_qual = function (scl) {

        var val = '';
        var qual = '';

        // handle the first quals in each school differently as these can't be removed
        _this.show_oth(scl, 1, $('select[data-scl="' + 1 + '"][data-qual="' + 1 + '"][data-qual-type]').val());

        val = $('select[data-scl="' + scl + '"][data-qual="' + 1 + '"][data-qual-type]').val();
        qual = 1;
        _this.show_oth(scl, qual, val);

        for (var count = 2; count <= max_qual_per_scl; count++) {

            var selector = $('input[type="text"][data-scl="' + scl + '"][data-qual="' + count + '"]');

            var pop_fields = selector.filter(function () {
                return this.value;
            }).length + selector.filter(function () {
                return this.value;
            }).length;
            if (pop_fields > 0) {
                // show the row and make the fields mandatory
                $('tr[data-scl="' + scl + '"][data-qual="' + count + '"]').removeClass('sv-hidden');
                $('input[type="text"][data-scl="' + scl + '"][data-qual="' + count + '"][data-qual-mand="true"]').prop('required', true);
                $('select[data-scl="' + scl + '"][data-qual="' + count + '"]').prop('required', true);

                val = $('select[data-scl="' + scl + '"][data-qual="' + count + '"][data-qual-type]').val();
                qual = count;
                _this.show_oth(scl, qual, val);
            }
        }

        // if no tr elements exist with the hidden class on then hide the add qual button (as no more quals availabel to add)
        var hidden = $('tr[data-scl="' + scl + '"][class="sv-hidden"]').attr('data-qual');
        if (!hidden) {
            $('input[id="add_qual"][data-scl="' + scl + '"]').hide();
        }
    };

    this.show_oth = function (scl, qual, val) {

        //console.log('scl: ' + scl + ' ' + 'qual: ' + qual + ' ' + 'val: ' + val);

        if (val === 'OTHER') {
            $('tr[data-scl="' + scl + '"][data-qual="' + qual + '"][data-qual-other]').removeClass('sv-hidden').find('input').prop('required', true);
        } else {
            $('tr[data-scl="' + scl + '"][data-qual="' + qual + '"][data-qual-other]').addClass('sv-hidden').find('input').val('').prop('required', false).removeAttr('required');
        }
    };

    // show the next school instance
    this.show_next_scl = function () {
        var scl2 = $('div[id="scl2"][class="sv-hidden"]').length;
        var scl3 = $('div[id="scl3"][class="sv-hidden"]').length;

        if (scl2 > 0) {
            $('div[id="scl2"]').removeAttr('class');
        } else if (scl3 > 0) {
            $('div[id="scl3"]').removeAttr('class');
        }

        _this.toggleAddSchoolButton();
    };

    this.remove_scl = function (scl) {

        var school = $('#scl' + scl);

        // null all of the fields in the schools
        school.find('input, select, textarea').each(function () {
            $(this).val('');
        });

        // remove all the qualifications for this school
        for (var i = 1; i <= max_qual_per_scl; i++) {
            this.remove_qual(scl, i);
        }

        // re-hide the school section
        school.attr('class', 'sv-hidden');

        // show the add a school button
        //_this.toggleAddSchoolButton();

        $('#but_save').trigger('click');
    };

    this.toggleAddSchoolButton = function () {
        var button = $('#add_scl');
        var hidden = $('div[id^="scl"][class="sv-hidden"]').length;
        button.toggleClass('sv-hidden', hidden === 0);
        button.parent('.well').toggleClass('sv-hidden', hidden === 0);
    };

    // show the next qualification row for the school instance
    this.show_next_qual = function (scl) {
        var next_qual = parseInt($('tr[data-scl="' + scl + '"][class="sv-hidden"]:not([data-qual-other]):first').attr('data-qual'));

        if (next_qual <= max_qual_per_scl && next_qual !== 'undefined') {

            $('tr[data-scl="' + scl + '"][data-qual="' + next_qual + '"]').not('[data-qual-other]').removeClass('sv-hidden');
            $('input[type="text"][data-scl="' + scl + '"][data-qual="' + next_qual + '"][data-qual-mand="true"]').prop('required', true);
            $('select[data-scl="' + scl + '"][data-qual="' + next_qual + '"]').prop('required', true);
        }

        // if no tr elements exist with the hidden class on then hide the add qual button (as no more quals availabel to add)
        var hidden = $('tr[data-scl="' + scl + '"][class="sv-hidden"]:not([data-qual-other])').attr('data-qual');
        if (!hidden) {
            $('input[id="add_qual"][data-scl="' + scl + '"]').hide();
        } else if (hidden > max_qual_per_scl) {
            $('input[id="add_qual"][data-scl="' + scl + '"]').hide();
        }
    };

    this.remove_qual = function (scl, qual) {

        // hide the row and null all of the fields within it
        // remove the required attribute from the fields

        // null the fields and remove the require attributes
        $('input[type="text"][data-scl="' + scl + '"][data-qual="' + qual + '"]').val('').removeAttr('required');
        $('select[data-scl="' + scl + '"][data-qual="' + qual + '"]').val('').removeAttr('required');

        // hide the qual rows
        $('tr[data-scl="' + scl + '"][data-qual="' + qual + '"]').attr('class', 'sv-hidden');

        // show the add qualification button
        $('input[id="add_qual"][data-scl="' + scl + '"]').show();
    };

    this.pop_scl = function (id, scl) {
        if (scl !== '' && scl !== 'undefined') {
            // populate the scl with the code and trigger the blur event
            $('#' + id).val(scl).blur();
        } else {
            // do anything that needs to happen if scl field is null
        }
    };
}

var educationDetails = new EducationDetails();

educationDetails.initEducationDetails();